import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { Actualite } from "../../../models/actualite";
import { ActualitesService } from "../../../services/actualites.service";
import { LogementService } from "../../../services/logement.service";
import { ExtraRouterService } from "../../../services/extra-router.service";
import { Logement } from "../../../models/logement";
import { DomSanitizer } from "@angular/platform-browser";
import { TwitterService } from '../../../services/twitter.service';
import { ErrorService } from "../../../services/error.service";

@Component({
    selector: 'app-actualite',
    templateUrl: './actualite.component.html',
    styleUrls: ['./actualite.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActualiteComponent implements OnInit {

  logement$: Observable<Logement> = null;

  actualite$: Observable<Actualite>;

  private subscription: Subscription;

  content: any = null;
  actualite: Actualite;

  // Une image par vue à toutes les tailles ; la pagination est gérée
  // nativement par Swiper, l'ancien <ul> de points n'est plus nécessaire.
  carouselSpeed = 250;


  constructor(
    private route: ActivatedRoute,
    private logementService: LogementService,
    private actualiteService: ActualitesService,
    public extraRouter: ExtraRouterService,
    public sanitizer: DomSanitizer,
    private twitterService: TwitterService,
    private errorService: ErrorService
  ) {
  }

  ngOnInit() {
    this.logement$ = this.logementService.logementCourant;
    this.subscription = this.logement$.subscribe(logement => {
      const logementId = this.logementService.getLogementCourantId();
      const type = this.route.snapshot.paramMap.get('type');
      const id = +this.route.snapshot.paramMap.get('id');

      if (type === 'QUALITEL' || logement.statut === 'FERME') {
        this.actualite$ = this.actualiteService.findQualitelActualite(logementId, type, id);

        this.actualite$.subscribe(actu => {
          this.actualite = actu;
          this.content = this.sanitizer.bypassSecurityTrustHtml(actu.contenu);
          this.twitterService.initWidget();
        });
      } else {
        this.actualiteService.findCarnetActualiteById(type, id).then((data: any) => {
          if (data instanceof Actualite) {
            this.actualite = data;
            this.content = this.sanitizer.bypassSecurityTrustHtml(data.contenu);
            this.twitterService.initWidget();
          } else {
            this.errorService.toastErrors(data.errors);
          }
        });
      }
    });
  }
}
